(() => {
  const source = document.currentScript?.dataset.fafSearchReturnSrc || '';
  let loadPromise = null;

  const relativeUrl = () => (
    window.location.pathname + window.location.search + window.location.hash
  );

  const hasRestorableState = () => {
    try {
      const raw = window.sessionStorage.getItem('faf:search-return:v1');
      if (!raw) return false;

      const state = JSON.parse(raw);
      const navigationType = window.performance
        ?.getEntriesByType?.('navigation')?.[0]?.type || '';
      const referrerIsProduct = /\/products\//.test(document.referrer || '');

      return Boolean(
        state &&
        state.version === 1 &&
        state.sourceUrl === relativeUrl() &&
        Date.now() - Number(state.savedAt || 0) <= 30 * 60 * 1000 &&
        (navigationType === 'back_forward' || referrerIsProduct)
      );
    } catch (_) {
      return false;
    }
  };

  const load = () => {
    if (window.__fafSearchReturnLoaded) return Promise.resolve();
    if (loadPromise) return loadPromise;
    if (!source) return Promise.reject(new Error('Search-return asset URL is missing.'));

    loadPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = source;
      script.async = true;
      script.onload = () => {
        window.__fafSearchReturnLoaded = true;
        resolve();
      };
      script.onerror = () => {
        script.remove();
        loadPromise = null;
        reject(new Error('Search-return asset could not be loaded.'));
      };
      document.head.appendChild(script);
    });

    return loadPromise;
  };

  const initialise = () => {
    const isSearchPage = Boolean(
      document.querySelector('[data-faf-search-page], [data-faf-search-page-v2]')
    );

    if (isSearchPage || hasRestorableState()) {
      load().catch((error) => console.warn(error.message));
    }
  };

  window.addEventListener('search-opened', () => {
    load().catch((error) => console.warn(error.message));
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise, { once: true });
  } else {
    initialise();
  }
})(); 
